import { lazy as lazyLoad } from 'react';

import type { RouteDefinition } from '../../route';

export const routes: readonly RouteDefinition[] = [
    {
        documentTitle: 'pages.learning-opportunity-recommendations-by-skill-ids.headline',
        page: lazyLoad(async () => {
            const { LearningOpportunityRecommendationsBySkillIdsPage } = await import(
                // eslint-disable-next-line @stylistic/comma-dangle
                './LearningOpportunityRecommendationsBySkillIdsPage'
            );

            return { default: LearningOpportunityRecommendationsBySkillIdsPage };
        }),
        path: '/learning-opportunity-recommendations',
    },
];
